import { UserData } from "../interface";

export const userForm = [
  {
    name: "user_name",
    label: "User Name",
    type: "text",
    placeholder: "Enter user name",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    placeholder: "name@example.com",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter password",
  },
];

export const userFields: UserData = {
  user_name: "",
  email: "",
  password: "",
  user_role: "admin",
};

export const loginFields = [
  {
    name: "email",
    type: "email",
    label: "Email",
    placeholder: "Your email address",
  },
  {
    name: "password",
    type: "password",
    label: "Password",
    placeholder: "Your password",
  },
];

export const resetPasswordFields = [
  {
    name: "password",
    label: "New Password",
    type: "password",
    placeholder: "Enter new password",
  },
  {
    name: "confirmPassword",
    label: "Confirm Password",
    type: "password",
    placeholder: "Confirm new password",
  },
];

export const userDropDowns = [
  { label: "Admin", value: "admin" },
  { label: "Editor", value: "editor" },
  { label: "Viewer", value: "viewer" },
];

export const variantForm = [
  {
    name: "url",
    label: "URL",
    type: "text",
    placeholder: "URL"
  }
]

export const variantFields = {
  url: ""
};
